"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var AgentMixin = /** @class */ (function () {
    function AgentMixin() {
    }
    AgentMixin.prototype.getStaff = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.MinimalStaff.parse, 'warn'));
        };
        this.http.get('/staff', null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgentMixin.prototype.getFullStaff = function (deactivated, callback) {
        var _this = this;
        var params = { model: 'full' };
        if (deactivated) {
            params.roles = 'deactivated';
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.FullStaff.parse, 'warn'));
        };
        this.http.get('/staff', params, this.unauthenticatedCallback(wrappedCallback));
    };
    AgentMixin.prototype.editAgent = function (agentId, roleId, callback) {
        var _this = this;
        var body = { roleId: roleId };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/staff/" + agentId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgentMixin.prototype.getAgentRoles = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.AgentRole.parse, 'warn'));
        };
        this.http.get('/agent-roles', null, this.unauthenticatedCallback(wrappedCallback));
    };
    return AgentMixin;
}());
exports.default = AgentMixin;
//# sourceMappingURL=AgentMixin.js.map